import { render } from "./Signup.vue?vue&type=template&id=07885af4"
import script from "./Signup.vue?vue&type=script&lang=js"
export * from "./Signup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/views/Signup.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "07885af4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('07885af4', __exports__)) {
    api.reload('07885af4', __exports__)
  }
  
  module.hot.accept("./Signup.vue?vue&type=template&id=07885af4", () => {
    api.rerender('07885af4', render)
  })

}


export default __exports__